export const firebaseConfig = {
  apiKey: "AIzaSyCNULBWfcEI-crZnvy_vHcaVWXssCUf5CE",
  authDomain: "ghast.firebaseapp.com",
  databaseURL: "https://ghast.firebaseio.com",
  storageBucket: "project-1029735015520686877.appspot.com"
};

// export const firebaseConfig = {
//   apiKey: "AIzaSyAdq9B1lL-yTMuFEw6yt0p4BSXkGQ7dViE",
//   authDomain: "ghast-dev.firebaseapp.com",
//   databaseURL: "https://ghast-dev.firebaseio.com",
//   projectId: "ghast-dev",
//   storageBucket: "ghast-dev.appspot.com",
//   messagingSenderId: "549796585478"
// };



/** WEBPACK FOOTER **
 ** ./src/core/firebase/config.js
 **/